import { ApolloClient, InMemoryCache } from "@apollo/client";
import { HttpLink } from "@apollo/client/core";
import { ApolloLink } from "@apollo/client/core";
import { createUploadLink } from "apollo-upload-client";

// globale setting
const AVC_BASE_url = process.env.REACT_APP_BASE_URL;

// AVC_BIO_Client
export const AVC_BIO_CONFIG = {
  AVC_BIO_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_BIO_uri: AVC_BASE_url + "/avc_bio",
};

// AVC_Ticketing_Client
export const AVC_TICKETING_CONFIG = {
  AVC_TICKETING_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_TICKETING_uri: AVC_BASE_url + "/avc_ticket",
};

// AVC_Notification_Client
export const AVC_NOTIFICATION_CONFIG = {
  AVC_NOTIFICATION_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_NOTIFICATION_uri: AVC_BASE_url + "/AVC_NOTIFICATIONENGINE",
};

// AVC_AAA_Client
export const AVC_AAA_CONFIG = {
  AVC_AAA_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_AAA_uri: AVC_BASE_url + "/avc_aaa",
};

// avc_profile
export const AVC_PROFILE_CONFIG = {
  AVC_PROFILE_uri: AVC_BASE_url + "/avc_profile",
  AVC_PROFILE_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
};

// avc_setting
export const AVC_SETTING_CONFIG = {
  AVC_PROFILE_uri: AVC_BASE_url + "/avc_setting",
  AVC_PROFILE_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
};

// AVC_Education_Client
export const AVC_EDUCATION_CONFIG = {
  AVC_Education_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_Education_uri: AVC_BASE_url + "/AVC_EDUCATION",
};

// AVC_BI_Client
export const AVC_BI_CONFIG = {
  AVC_BI_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_BI_uri: AVC_BASE_url + "/AVC_BI",
};

// AVC_WALLET_CREDIT_Client
export const AVC_WALLET_CREDIT_CONFIG = {
  AVC_Wallet_Credit_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_Wallet_Credit_uri: AVC_BASE_url + "/AVC_WalletCredit",
};

// AVC_CORRESPONDENCEMANAGEMENT_CONFIG
export const AVC_CORRESPONDENCEMANAGEMENT_CONFIG = {
  AVC_CORRESPONDENCEMANAGEMENT_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_CORRESPONDENCEMANAGEMENT_uri: AVC_BASE_url + "/avc_correspondence",
};

// AVC_PERSONNAL_MANAGMENT_Client
export const AVC_PERSONNAL_MANAGMENT_CONFIG = {
  AVC_PERSONNAL_MANAGMENT_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_PERSONNAL_MANAGMENT_uri: AVC_BASE_url + "/avc_personnel",
};

// AVC_SITE_Client
export const AVC_SITE_CONFIG = {
  AVC_SITE_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_SITE_uri: AVC_BASE_url + "/avc_site",
};

// AVC_LICENSE_Client
export const AVC_LICENSE_CONFIG = {
  AVC_LICENSE_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_LICENSE_uri: AVC_BASE_url + "/avc_lic",
};

// AVC_MARKETING_CONFIG
export const AVC_MARKETING_CONFIG = {
  AVC_MARKETING_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_MARKETING_uri: AVC_BASE_url + "/avc_marketing",
};

// AVC_PROSRV_Client
export const AVC_PROSRV_CONFIG = {
  AVC_PROSRV_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_PROSRV_uri: AVC_BASE_url + "/avc_pro_srv",
};

// AVC_ORDERS_MANAGEMENT_Client
export const AVC_ORDERS_MANAGEMENT_CONFIG = {
  AVC_ORDERS_MANAGEMENT_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_ORDERS_MANAGEMENT_uri: AVC_BASE_url + "/AVC_ORDERS_MANAGEMENT",
};

// AVC_TRANSPORTATION_Client
export const AVC_TRANSPORTATION_CONFIG = {
  AVC_TRANSPORTATION_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_TRANSPORTATION_uri: AVC_BASE_url + "/AVC_TRANSPORTATION",
};

// AVC_LABORATORY_Client
export const AVC_LABORATORY_CONFIG = {
  AVC_LABORATORY_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_LABORATORY_uri: AVC_BASE_url + "/AVC_LABORATORY",
};

// AVC_TRACKING_Client
export const AVC_TRACKING_CONFIG = {
  AVC_TRACKING_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_TRACKING_uri: AVC_BASE_url + "/AVC_TRACKING",
};

// AVC_FEED_Client
export const AVC_FEED_CONFIG = {
  AVC_FEED_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_FEED_uri: AVC_BASE_url + "/AVC_FEED",
};

// AVC_WATER_MANAGEMENT_Client
export const AVC_WATER_MANAGEMENT_CONFIG = {
  AVC_WATER_MANAGEMENT_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_WATER_MANAGEMENT_uri: AVC_BASE_url + "/avc_water",
};

// AVC_ENERGY_MANAGEMENT_Client
export const AVC_ENERGY_MANAGEMENT_CONFIG = {
  AVC_ENERGY_MANAGEMENT_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_ENERGY_MANAGEMENT_uri: AVC_BASE_url + "/avc_energy_management",
};

// AVC_FACILITIES_Client
export const AVC_FACILITIES_CONFIG = {
  AVC_FACILITIES_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_FACILITIES_uri: AVC_BASE_url + "/avc_facilities",
};

// AVC_WAREHOUSE_Client
export const AVC_WAREHOUSE_CONFIG = {
  AVC_WAREHOUSE_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_WAREHOUSE_uri: AVC_BASE_url + "/avc_warehouse",
};

// AVC_PRODUCTION_LINE_Client
export const AVC_PRODUCTION_LINE_CONFIG = {
  AVC_PRODUCTION_LINE_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_PRODUCTION_LINE_uri: AVC_BASE_url + "/avc_production_line",
};

// AVC_AUDITCONTROL_Client
export const AVC_AUDITCONTROL_CONFIG = {
  AVC_AUDITCONTROL_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_AUDITCONTROL_uri: AVC_BASE_url + "/AVC_AUDITCONTROL",
};

// AVC_AQUACULTURE_MANAGEMENT_Client
export const AVC_AQUACULTURE_MANAGEMENT_CONFIG = {
  // includes(BroodStock , Hatchery ,Aquaculture , Nursery )
  AVC_AQUACULTURE_MANAGEMENT_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_AQUACULTURE_MANAGEMENT_uri: AVC_BASE_url + "/AVC_AquacultureManagement",
};

// AVC_PROCESSING_PLANT_Client
export const AVC_PROCESSING_PLANT_CONFIG = {
  AVC_PROCESSING_PLANT_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_PROCESSING_PLANT_uri: AVC_BASE_url + "/AVC_ProcessingPlant",
};

// AVC_COLD_STORAGE_Client
export const AVC_COLD_STORAGE_CONFIG = {
  AVC_COLD_STORAGE_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_COLD_STORAGE_uri: AVC_BASE_url + "/AVC_ColdStorage",
};

// AVC_FISHERIES_MANAGEMENT_Client
export const AVC_FISHERIES_MANAGEMENT_CONFIG = {
  AVC_FISHERIES_MANAGEMENT_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_FISHERIES_MANAGEMENT_uri: AVC_BASE_url + "/AVC_FISHERIES_MANAGEMENT",
};

// AVC_LOADING_UNLOADING_Client
export const AVC_LOADING_UNLOADING_CONFIG = {
  AVC_LOADING_UNLOADING_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_LOADING_UNLOADING_uri: AVC_BASE_url + "/AVC_LOADINGUNLOADING",
};

// AVC_DISTRIBUTION_Client
export const AVC_DISTRIBUTION_CONFIG = {
  AVC_DISTRIBUTION_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_DISTRIBUTION_uri: AVC_BASE_url + "/AVC_Distribution",
};

// AVC_IMPORTATION_AND_EXPORTATION_Client
export const AVC_IMPORT_EXPORT_CONFIG = {
  AVC_IMPORT_EXPORT_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_IMPORT_EXPORT_uri: AVC_BASE_url + "/avc_import_export"
};

// AVC_ORGANIZATION_Client
export const AVC_ORGANIZATION_CONFIG = {
  AVC_ORGANIZATION_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_ORGANIZATION_uri: AVC_BASE_url + "/AVC_Organization",
};

// AVC_SERVICE_Client
export const AVC_SERVICE_MANAGEMENT_CONFIG = {
  AVC_SERVICE_MANAGEMENT_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_SERVICE_MANAGEMENT_uri: AVC_BASE_url + "/AVC_SERVICE",
};

// AVC_Orchestrator_Client
export const AVC_Orchestrator_CONFIG = {
  AVC_ORCHESTRATOR_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_ORCHESTRATOR_uri: AVC_BASE_url + "/AVC_Orchestrator",
};

// AVC_WEATHER_MANAGEMENT_Client
export const AVC_WEATHER_MANAGEMENT_CONFIG = {
  AVC_WEATHER_MANAGEMENT_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_WEATHER_MANAGEMENT_uri: AVC_BASE_url + "/AVC_WeatherManagement",
};

// AVC_SMART_ASSISTANT_Client
export const AVC_SMART_ASSISTANT_CONFIG = {
  AVC_SMART_ASSISTANT_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_SMART_ASSISTANT_uri: AVC_BASE_url + "/AVC_SmartAssistant",
};

// File Manager
export const AVC_ObjectFile_CONFIG = {
  AVC_ObjectFile_Wso2Token: process.env.REACT_APP_UIAW_TOKEN,
  AVC_ObjectFile_uri: AVC_BASE_url + "/avc_filestorage",
  AVC_uploadFile_uri: AVC_BASE_url + "/uploadfile",
};

//////////////////////////////////////////////////////////////

const AVC_ObjectFile_endpoint = new createUploadLink({
  //credentials: "include",
  //uri:"http://192.168.23.47:8023/graphql",
  //headers: {
  //Microservice:config.Microservice,
  //Authorization:"",
  //AuthorizationWSO2:"Bearer "+Cookies.get("nmzbxcbashsaoisd"),
  //},
  //uri: AVC_ObjectFile_CONFIG.AVC_uploadFile_uri,
  // headers: {
  //   AuthorizationWSO2: AVC_ObjectFile_CONFIG.AVC_ObjectFile_Wso2Token,
  //   //Authorization: "",
  // },
});

const AVC_AAA_endpoint = new HttpLink({
  uri: AVC_AAA_CONFIG.AVC_AAA_uri,
});

// apollo clinet
const AVC_httpLink = ApolloLink.split(
  (operation) => operation.getContext().hasUpload,
  AVC_ObjectFile_endpoint,
  AVC_AAA_endpoint
);

export const AVC_AAA_client = new ApolloClient({
  link: AVC_httpLink,
  cache: new InMemoryCache(),
});

export default AVC_AAA_client;
